import React from "react";
import NodePorts from "./NodePorts";
import { makeStyles } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { Settings } from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  nodeContainer: {
    minWidth: 200,
    maxWidth: 280,
    padding: theme.spacing(1.5, 2),
    borderRadius: 8,
    background: "#111827",
    border: "1px solid rgba(255, 255, 255, 0.2)",
    color: "white",
  },
  nodeHeader: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
  nodeIcon: {
    fontSize: 20,
  },
  nodeLabel: {
    fontWeight: 600,
    fontSize: 14,
    color: "white",
  },
  nodeContent: {
    fontSize: 12,
    opacity: 0.9,
    padding: theme.spacing(0.75),
    backgroundColor: "rgba(0, 0, 0, 0.2)",
    borderRadius: 4,
  },
  handle: {
    width: 12,
    height: 12,
    background: "white",
    border: "2px solid #111827",
    borderRadius: "50%",
  },
}));

const SetVariableNode = ({ data, selected }) => {
  const classes = useStyles();
  const key = data?.key || data?.variable || "";
  const value = data?.value ?? "";

  return (
    <Box
      className={classes.nodeContainer}
      style={{
        border: selected ? "2px solid rgba(255, 255, 255, 0.5)" : "1px solid rgba(255, 255, 255, 0.2)",
      }}
    >
      <NodePorts color="#111827" />
      <Box className={classes.nodeHeader}>
        <Settings className={classes.nodeIcon} />
        <Typography className={classes.nodeLabel}>Set variable</Typography>
      </Box>
      <Box className={classes.nodeContent}>
        {key ? `${key} = ${String(value)}` : "Configurar variable"}
      </Box>
    </Box>
  );
};

export default SetVariableNode;

